'use strict';

var util = require('util');

var getPolyfill = require('./polyfill');

module.exports = function shimUtilPromisify() {
  var polyfill = getPolyfill();

  if (polyfill !== util.promisify) {
    util.promisify = polyfill;
    Object.defineProperty(util, 'promisify', {
      value: polyfill
    });
  }

  return polyfill;
};